import i18next from "i18next"
import { DEFAULT_LANGUAGE, SupportedLanguage } from "../constants"

export const changeLanguage = async (lng: SupportedLanguage) => {
  try {
    await i18next.changeLanguage(lng)
    localStorage.setItem(`i18nextLng`, lng)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
  }
}

export const getLanguage = (): SupportedLanguage =>
  (localStorage.getItem(`i18nextLng`) as SupportedLanguage) || DEFAULT_LANGUAGE

// Create an helper function that get a string and if it contains a word between ** it will return the word in bold
export const boldify = (text: string) => {
  const boldRegex = /\*\*(.*?)\*\*/g
  return text.replace(boldRegex, `<strong>$1</strong>`)
}

// Create an helper function that get a string and if it contains a word between __ it will return the word in italic
export const italicize = (text: string) => {
  const italicRegex = /__(.*?)__/g
  return text.replace(italicRegex, `<em>$1</em>`)
}
